import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_UsageChart = _resolveComponent("UsageChart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fetchUser && _ctx.fetchUser(...args))),
      disabled: _ctx.isSubmitting,
      class: "btn btn-primary"
    }, "Token History", 8, _hoisted_1),
    (_ctx.errorText.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Alert, {
            type: "danger",
            text: _ctx.errorText
          }, null, 8, ["text"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.data.length > 0)
            ? (_openBlock(), _createBlock(_component_UsageChart, {
                key: 0,
                data: _ctx.data
              }, null, 8, ["data"]))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, "No usage during this time period."))
        ]))
      : (_ctx.isSubmitting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true)
  ]))
}